export const ALL_FILTER = { key: 'ALL', title: 'Все' }
